import { useSelector } from 'react-redux';

const useReferenceData = () => {
    return useSelector(state => state.authenticateReducer.referenceData) || {};
};

export default useReferenceData;
